import { IconButton, Stack } from "@chakra-ui/react";
import {
  DrawerBackdrop,
  DrawerBody,
  DrawerCloseTrigger,
  DrawerContent,
  DrawerRoot,
  DrawerTrigger,
} from "../../ui/drawer";
import styles from "./navigation.module.scss";
import { HiMenu } from "react-icons/hi";

interface MobileNavigationProps {
  isOpen: boolean;
  setIsOpen: (val: boolean) => void;
  items: string[];
}

const MobileNavigation: React.FC<MobileNavigationProps> = ({
  isOpen,
  setIsOpen,
  items,
}) => {
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div className={styles.mobileMenuOptions}>
      <DrawerRoot
        open={isOpen}
        onOpenChange={(e) => setIsOpen(e.open)}
        placement="end"
      >
        <DrawerBackdrop />
        <DrawerTrigger asChild>
          <IconButton
            size="lg"
            aria-label="Open menu"
            variant="ghost"
          >
            <HiMenu size={24} />
          </IconButton>
        </DrawerTrigger>
        <DrawerContent className={styles.drawer}>
          <DrawerCloseTrigger />
          <DrawerBody>
            <Stack gap={4} mt={8}>
              {items.map((page) => (
                <div
                  key={page}
                  className={styles.mobileMenuItem}
                  onClick={handleClose}
                >
                  <a href={`#${page}`}>{page}</a>
                </div>
              ))}
            </Stack>
          </DrawerBody>
        </DrawerContent>
      </DrawerRoot>
    </div>
  );
};

export default MobileNavigation;
